export default {"src":"/_next/static/media/scalerLogo.e910c80a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};